export const getFileUrl = file => {
  if (file.substr(0, 4) !== 'http') {
    return `${process.env.NEXT_PUBLIC_SERVER_PUBLIC_URL}/storage/${file}`;
  }

  return file;
};
